import api from "./api";

class AuthService {
    login(username, password) {
        return api.post("/api/auth/login/", { username, password });
    }

    logout() {
        return api.post("/api/auth/logout/");
    }

    verify() {
        return api.get("/api/auth/verify/");
    }

    forgotPassword(email) {
        return api.post("/api/auth/forgot-password/", { email });
    }

    resetPassword(uid, token, new_password) {
        return api.post("/api/auth/reset-password/", {
            uid,
            token,
            new_password,
        });
    }
}

export default new AuthService();
